import { Severity, usePushNotifications } from 'services/NotificationService';
import { useMutation } from '@apollo/react-hooks';
import {
  EditPixelTrackingAppMutation,
  EditPixelTrackingAppMutationVariables
} from './__generated__/EditPixelTrackingAppMutation';
import { EDIT_PIXEL_APP_MUTATION } from './editPixelApp.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: () => void;
  onError?: () => void;
};

export const useEditPixelApp = ({ onStart, onCompleted, onError }: MutationProps) => {
  const notify = usePushNotifications();
  const [editPixelApp] = useMutation<EditPixelTrackingAppMutation, EditPixelTrackingAppMutationVariables>(
    EDIT_PIXEL_APP_MUTATION,
    {
      refetchQueries: ['PixelAppsQuery'],
      onCompleted: (data) => {
        if (data.editPixelTrackingApp?.errors?.length) {
          if (onError) onError();
          notify({ title: 'Error', message: data.editPixelTrackingApp.errors[0], severity: Severity.ERROR });
        } else {
          if (onCompleted) onCompleted();
          notify({ title: 'Success', message: 'Pixel App was edited successfully!', severity: Severity.SUCCESS });
        }
      },
      onError: () => onError && onError()
    }
  );
  return (variables: EditPixelTrackingAppMutationVariables) => {
    if (onStart) onStart();
    editPixelApp({
      variables
    });
  };
};
